import React from 'react';
import { useTranslation } from 'react-i18next';

import { X } from 'lucide-react';

import { closeModal } from '@/components/modals/modals.utils';
import { ModalBase } from '@/components/modals/modals-base';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

export interface RenameArchiveItemModalProps {
  currentName: string;
  title?: string;
  onSubmit: (newName: string) => void | Promise<void>;
}

export const RenameArchiveItemModal: React.FC<RenameArchiveItemModalProps> = ({
  currentName,
  title,
  onSubmit,
}) => {
  const { t } = useTranslation();
  const [name, setName] = React.useState(currentName);
  const [loading, setLoading] = React.useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!name || name === currentName) return closeModal();
    try {
      setLoading(true);
      await onSubmit(name.trim());
      closeModal();
    } finally {
      setLoading(false);
    }
  };

  return (
    <ModalBase className="min-w-[360px]">
      <X
        className="absolute right-3 top-3 cursor-pointer text-slate-500 hover:text-slate-700"
        onClick={closeModal}
        aria-label="Close"
      />
      {title ? (
        <h3 className="mb-4 pr-6 text-md">{title}</h3>
      ) : (
        <h3 className="mb-4 pr-6 text-md">{t('rename')}</h3>
      )}
      <form onSubmit={handleSubmit} className="space-y-4">
        <Input label={t('name')} value={name} onChange={(e) => setName(e.target.value)} autoFocus />
        <div className="mt-8 grid grid-cols-2 gap-4">
          <Button onClick={closeModal} variant="outline" className="border-red-500 text-red-500">
            {t('cancel')}
          </Button>
          <Button type="submit" disabled={loading}>
            {t('save')}
          </Button>
        </div>
      </form>
    </ModalBase>
  );
};
